import React, 
       { useEffect, 
         useState }                 from 'react';
import { useNavigate }              from 'react-router-dom';
import { Container, 
         Form, 
         Button,
         Row, 
         Col}                       from 'react-bootstrap';
import api                          from './AxiosConfig';
import { BsTrashFill }              from 'react-icons/bs';

function GoalDetailsUpdateRM( { selGoal, refresh } ) {
  const [goal,    setGoal]                  = useState();
  const [message, setMessage]               = useState( "" );
  const [subGoalItems, setSubGoalItems]     = useState( [] );
  const [newSubGoalItem, setNewSubGoalItem] = useState( { name: "",  
                                                          description: "",
                                                          target: 0.0, 
                                                          start: 0.0
                                                        });
  const navigate                        = useNavigate();

  useEffect(() => {
    if (selGoal) {
        setGoal(selGoal);
    }
  }, [selGoal]); // Runs when initialData changes

  useEffect(() => {
      async function getSubGoalItems() {
          if ( goal && goal.id ) {
              try {
                  const response = await api.get(`/site/radar-goals/${encodeURIComponent(goal.id)}`, {withCredentials: true });
                  setSubGoalItems(response.data);
              } catch (error) {
                  console.log("getSubGoalItems: " + error);
              }
          }
      }
      // Fetch the progress record for this goal.
      getSubGoalItems();
  }, [goal]); 
       
  // Format date for date form control.
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
       
  // Handle input change
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setGoal((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdateDetails = async () => {
       try {
           const response = await api.put(`/site/goals/${encodeURIComponent(goal.id)}`, { goal }, {withCredentials: true });
           console.log("PUT /site/goals/ = " + JSON.stringify(response.data));
           setMessage(response.data.message);
       } catch (error) {
           console.log("subGoalRow: " + error);
       }
  }
       
  const handleArchiveGoal = async () => {
        try {
            const response = await api.put(`/site/goals/archived/${encodeURIComponent(goal.id)}/1`, { goal }, {withCredentials: true });
            setMessage(response.data.message);  // Display success message from server
            navigate('/status', {});
        } catch (error) {
            if (error.response) {
                // The updated goal record is returned if the update was successful.
                setMessage(error.response.data.message);  // Display error message from server
            } else {
                setMessage('An error occurred during update');
            }
        }
    };

  const handleAddSGItem = async () => {
       try {
            const response = await api.put(`/site/radar-goals/add/${encodeURIComponent(goal.id)}`, { newSubGoalItem }, {withCredentials: true });
            setMessage(response.data.message);
            setNewSubGoalItem({name: "", description: "", target: 0.0, start: 0.0});
            refresh();
       } catch (error) {
           if (error.response) {
                setMessage(error.response.data.message);  // Display error message from server
            } else {
                setMessage('An error occurred during update');
            }
        }         
  };

const updateSGItemAtIndex = (e, index) => {
      const { name, value } = e.target;
      setSubGoalItems(prev =>
          prev.map((item, idx) =>
          idx === index
          ? { ...item, [name]: value }   
          : item                           
          )
    );
  };
       
const handleUpdateSGItems = async () => {
       try {
           for (let c = 0; c < subGoalItems.length ; c++) {
               const response = await api.put(`/site/radar-goals/${encodeURIComponent(goal.id)}/${encodeURIComponent(subGoalItems[c].id)}`, { subGoalItem: subGoalItems[c] }, {withCredentials: true });
               console.log("update:" + c + " = " + JSON.stringify(subGoalItems[c]) + " response:" + response.data.message);
               setMessage(response.data.message); 
           }
           refresh();
       } catch (error) {
           console.log("subGoalRow: " + error);
       }
  }       
const handleDeleteSGItem = async (i) => {
       try {
           const response = await api.delete(`/site/radar-goals/${encodeURIComponent(subGoalItems[i].id)}`, {withCredentials: true });
           setMessage(response.data.message); 
           refresh();
       } catch (error) {
           console.log("subGoalRow: " + error);
       }
  }
       
  const updateNewSGItem = (e) => {
      const { name, value } = e.target;
      setNewSubGoalItem( (prevData) => ({
        ...prevData,
        [name]: value,
      }));
  };
              
  return (
    <Container className="mt-4">
      { goal ? ( 
      <>
      <Form>
        {/* Goal Title */}
        <Form.Group as={Row} className="mb-3" controlId="formTitle">
          <Form.Label column className="text-end">
            Title
          </Form.Label>
          <Col>
            <Form.Control type="text" value={goal.goal_title} name="goal_title" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Goal Description */}
        <Form.Group as={Row} className="mb-3" controlId="formDescription">
          <Form.Label column className="text-end">
            Description
          </Form.Label>
          <Col>
            <Form.Control type="text" value={goal.goal_description} name="goal_description" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Target Date */}
        <Form.Group as={Row} className="mb-3" controlId="formTargetDate">
          <Form.Label column className="text-end">
            Target Date
          </Form.Label>
          <Col>
            <Form.Control type="date" value={formatDate(goal.target_date)} name="target_date" onChange={handleInputChange} />
          </Col>
        </Form.Group>
        {/* Start Date */}
        <Form.Group as={Row} className="mb-3" controlId="formStartDate">
          <Form.Label column className="text-end">
            Start Date
          </Form.Label>
          <Col>
            <Form.Control type="date" value={formatDate(goal.start_date)} name="start_date" onChange={handleInputChange} />
          </Col>
        </Form.Group>
         
        {/* Submit Button */}
        <Form.Group as={Row} className="mt-4">
          <Col className="text-center">
            <Button variant="primary" size="sm" onClick={() => handleUpdateDetails()}>
              Update Details
            </Button>
          </Col>
          <Col className="text-end">
            <Button variant="primary" size="sm" onClick={() => handleArchiveGoal()}>
              Archive Goal
            </Button>
          </Col>
        </Form.Group>
      </Form>

      <div className={"card-goal-seperator"}>Edit Sub-Goals</div>
      <Form>
      { subGoalItems.map( (item, index) => (
         <>
         <div className={"content-container "} >
           <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
             <Form.Control className={"w-100 flex-grow-1"} type="text" value={item.name} name="name" onChange={e => updateSGItemAtIndex( e, index)} />
           </div>
           <div className={"right-content d-flex align-items-center"}>
             <Form.Control type="text" value={item.start} name="start" onChange={e=> updateSGItemAtIndex( e, index)} />
             <Form.Control type="text" value={item.target} name="target" onChange={e=> updateSGItemAtIndex( e, index)} />
             <BsTrashFill  onClick={() => handleDeleteSGItem(index)}/>
           </div>
         </div>
         <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
           <Form.Control className={"w-100 flex-grow-1"} type="text" value={item.description} name="description" onChange={e => updateSGItemAtIndex( e, index)} />
         </div>             
         </>
      ))} 
         <Form.Group as={Row} >
           <Col className="text-center"><Button variant="primary" size="sm" onClick={() => handleUpdateSGItems()}>Update Records</Button></Col>
         </Form.Group>
      </Form>
      <div className={"card-goal-seperator"}>Create New Sub-Goal</div>             
      <Form>
         <div className="content-container">
           <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
               <Form.Control type="text" className={"w-100 flex-grow-1"} value={newSubGoalItem.name} name="name" onChange={e => updateNewSGItem( e )} />
           </div>
           <div className={"right-content d-flex align-items-center"}>
               <Form.Control type="text" value={newSubGoalItem.start} name="start" onChange={e=> updateNewSGItem( e )} />    
               <Form.Control type="text" value={newSubGoalItem.target} name="target" onChange={e=> updateNewSGItem( e )} />    
               <Button variant="primary" size="sm" onClick={() => handleAddSGItem()}>+</Button>
           </div>
         </div>
         <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
           <Form.Control type="text" className={"w-100 flex-grow-1"} value={newSubGoalItem.description} name="description" onChange={e => updateNewSGItem( e )} />
         </div>
      </Form>
                     
      <p>{message}</p>
      </> ) : ( <p>Loading data...</p> )}
    </Container>           
  );
}

export default GoalDetailsUpdateRM;
